import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import twemoji from 'twemoji';

@Pipe({
  name: 'twemoji',
  standalone: false
})

export class TwemojiPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) { }


  transform(value: string): SafeHtml {
    if (!value) return '';

    let html = value;

    // HTML malicioso
    html = html.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');

    // Linkify
    const urlRegex = /((https?:\/\/)?([a-zA-Z0-9.-]+\.[a-zA-Z]{2,})(\/[^\s]*)?)/g;

    html = html.replace(urlRegex, (match) => {
      let url = match;

      if (!url.startsWith('http')) {
        url = 'https://' + url;
      }

      return `<a href="${url}" target="_blank" class="blueLink">${match}</a>`;
    });

    // Saltos de línea
    html = html.replace(/\n/g, '<br>');

    // Twemoji 
    html = twemoji.parse(html, {
      folder: 'svg',
      ext: '.svg',
      className: 'emoji'
    });

    return this.sanitizer.bypassSecurityTrustHtml(html);
  }
}
